// extracted by mini-css-extract-plugin
module.exports = {"mergeFieldsSection":"src-hellospa-components-deep-integration-merge-fields-index__mergeFieldsSection--3GGwL"};